import { Container, Typography } from '@mui/material'

const About = () => {
  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        ℹ️ About
      </Typography>

      <Typography>
        Yuva ChangeMaker is a youth-driven initiative to inspire social change.
      </Typography>
    </Container>
  )
}

export default About
